import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FunctionComponent} from 'react';
import {Card} from '../../components/Card';
import {mainState} from '../../AppMainState';
import {UserAuthApi} from '../../swagger';
import {showCommunicationError} from '../../helpers/alerts';
import {Button} from '../../components/Button';

function acceptTermsOfUse() {
    mainState.currentUser!.acceptedTermsOfUse = true;
    new UserAuthApi().apiUserAuthAcceptTermsOfUsePut().catch((err) => {
        showCommunicationError(err);
    });
    mainState.redirectToDashboard();
}

export const TermsOfUseView: FunctionComponent<any> = observer(() => {
    return (
        <section className="">
            <h1 className="mb-4">Accept terms of service</h1>
            <Card>
                <article className="overflow-y-scroll" style={{height: window.innerHeight - 280}}>
                    <ol>
                        <li>
                            <h2 className="m-0">Your relationship with company</h2>
                            <ol>
                                <li>
                                    Your use of DROP TABLE USERS's services and web sites (referred to as the
                                    "Service" or "Services" in this document and excluding any services provided to you
                                    by DROP TABLE USERS under a separate written agreement) is subject to the terms of
                                    a legal agreement between you and DROP TABLE USERS. "DROP TABLE USERS" means
                                    DROP TABLE USERS; Michał Zubkowicz.
                                </li>
                                <li>
                                    Unless otherwise agreed in writing with DROP TABLE USERS, your agreement with
                                    DROP TABLE USERS will always include, at a minimum, the terms and conditions set
                                    out in this document.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 className="m-0">Accepting the Terms</h2>
                            <p>
                                In order to use the Services, you must first agree to the Terms. You may not use the
                                Services if you do not accept the Terms.
                            </p>
                        </li>
                        <li>
                            <h2 className="m-0">Provision of the Services by DROP TABLE USERS</h2>
                            <ol>
                                <li>
                                    By accepting this agreement you acknowledge and agree that you have the sole
                                    responsibility of ensuring that the integration with DROP TABLE USERSs services
                                    does not interrupt normal operation of your site. DROP TABLE USERS WILL UNDER NO
                                    CIRCUMSTANCES BE LIABLE FOR ANY DISRUPTIONS OR DAMAGES INCURRED BY USING THE
                                    SERVICES.
                                </li>
                                <li>
                                    You acknowledge and agree that if DROP TABLE USERS disables access to your
                                    account, you may be prevented from accessing the Services.
                                </li>
                                <li>
                                    You agree that you are responsible for providing an accurate and updated email
                                    address when registering for the Services DROP TABLE USERS provide and for as long
                                    as you remain a user of these Services.
                                </li>
                                <li>
                                    You agree that DROP TABLE USERS may contact you by email and that they may notify
                                    you directly via the website or Service.
                                </li>
                                <li>
                                    You agree that you will remove the scripts that gives you access to the Service if
                                    you are instructed to do so and that DROP TABLE USERS may charge you and/or
                                    disable your usage of the Service centrally.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 className="m-0">Limitations of Services</h2>
                            <ol>
                                <li>
                                    By accepting this agreement you acknowledge that DROP TABLE USERS may establish
                                    limits concerning use of the Services, including the maximum number of days that
                                    content will be retained by the Service, the maximum number and size of loged
                                    entries or other content that may be transmitted or stored by the Service, the
                                    frequency with which you may access the Services and the locations where the Service
                                    is available.
                                </li>
                                <li>
                                    You acknowledge and agree that DROP TABLE USERS has no responsibility or liability
                                    for the deletion or failure to store any content maintained or transmitted by the
                                    Service.
                                </li>
                                <li>
                                    You acknowledge that DROP TABLE USERS reserves the right at any time to modify or
                                    discontinue the Services (or any part thereof) with or without notice, and that
                                    DROP TABLE USERS shall not be liable to you or to any third party for any
                                    modification, suspension or discontinuance of the Services.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 className="m-0">Use of the Services by you</h2>
                            <ol>
                                <li>
                                    In order to access certain Services, you may be required to provide information
                                    about yourself (such as identification or contact details) as part of the
                                    registration process for the Service, or as part of your continued use of the
                                    Services. You agree that any registration information you give to DROP TABLE USERS
                                    will always be accurate, correct and up to date.
                                </li>
                                <li>
                                    You agree that you will not engage in any activity that interferes with or disrupts
                                    the Services (or the servers and networks which are connected to the Services).
                                </li>
                                <li>
                                    Unless you have been specifically permitted to do so in a separate agreement with
                                    DROP TABLE USERS, you agree that you will not reproduce, duplicate, copy, sell,
                                    trade or resell the Services for any purpose.
                                </li>
                                <li>
                                    You agree that you are solely responsible for (and that DROP TABLE USERS has no
                                    responsibility to you or to any third party for) any breach of your obligations
                                    under the Terms and for the consequences (including any loss or damage which
                                    DROP TABLE USERS may suffer) of any such breach.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 className="m-0">Your accounts and passwords security</h2>
                            <ol>
                                <li>
                                    You agree and understand that you are responsible for maintaining the
                                    confidentiality of passwords associated with any account you use to access the
                                    Services.
                                </li>
                                <li>
                                    Accordingly, you agree that you will be solely responsible to DROP TABLE USERS for
                                    all activities that occur under your account.
                                </li>
                                <li>
                                    If you become aware of any unauthorized use of your password or of your account, you
                                    agree to notify DROP TABLE USERS immediately.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 className="m-0">Privacy and your personal information</h2>
                            <ol>
                                <li>
                                    Please read DROP TABLE USERS's privacy policy at http://www.muscula.com/privacy.
                                    This policy explains how DROP TABLE USERS treats your personal information, and
                                    protects your privacy, when you use the Services.
                                    <p>
                                        The administrator of your personal data processed for the purposes of providing
                                        services within the Service is DROP TABLE USERS with its registered office in
                                        Birnbaumweg 9, Neumünster, Germany (hereinafter: "Controller").
                                    </p>
                                </li>
                                <li>
                                    In all matters related to the processing of your personal data, you can contact the
                                    Service at the following e-mail address: Birnbaumweg 9, Neumünster.
                                </li>
                                <li>
                                    Depending on the activity you undertake in the Service, the scope of the data
                                    processed may vary. This is due to the fact that not all of the services we propose
                                    require the provision of a full range of personal data. In the case of registration
                                    on the Website, we will process email.
                                </li>
                                <li>
                                    The purpose of the processing is Identification and creation of an individual user
                                    account on the site. (Article 6 paragraph b Regulation of the European Parliament
                                    and of the Council (EU) 2016/679 of 27 April 2016 on the protection of individuals
                                    with regard to the processing of personal data and on the free movement of such data
                                    and the repeal of Directive 95/46 / EC (general regulation on data protection )
                                    (hereinafter: GDPR); contact with the Service user for information on marketing
                                    offers and commercial information. (Article 6 paragraph b and f of GDPR and the
                                    legally legitimate interest of the administrator).
                                </li>
                                <li>
                                    More information about the processing of your data can be found in the Privacy
                                    Policy, which is an integral part of these Regulations.
                                </li>
                                <li>
                                    Your personal data will be processed only for a period no longer than is necessary
                                    for the purpose for which the data is processed. Of course, you can always request
                                    us to access your data, correct it or delete it. After the above-mentioned periods,
                                    your data is deleted or anonymized.
                                </li>
                                <li>
                                    As the administrator of your data, we provide you with the right to access your
                                    data, you can also correct it, request its removal or limit their processing. You
                                    can also use the right to submit to the Service your opposition to the processing of
                                    your data and the right to transfer data to another data controller. If you want to
                                    use any of these rights - please contact us in the manner indicated in this Policy.
                                    <p>
                                        We also inform you that you have the right to lodge a complaint with the body
                                        supervising compliance with personal data protection regulations.
                                    </p>
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 className="m-0">Proprietary rights</h2>
                            <p>
                                The Service contains content and technology of DROP TABLE USERS that is protected by
                                copyright, trademark, patent, trade secret and other laws. DROP TABLE USERS owns
                                intellectual property rights to any protectable part of the Service, including but not
                                limited to the design, artwork, logos, functionality, and documentation (collectively,
                                the "Company Property"). You may not copy, modify, or reverse engineer any part of the
                                Service owned by DROP TABLE USERS.
                            </p>
                        </li>
                        <li>
                            <h2 className="m-0">Account registration and fees</h2>
                            <p>
                                In order to use the Services, you must register and create an account with DROP TABLE USERS
                                on the Site. DROP TABLE USERS offers various types of accounts, including a free
                                account and a paid account. DROP TABLE USERS reserves the right to suspend or
                                terminate your account at any time. A valid credit card is required for paid accounts.
                                The Services are billed in advance on a monthly basis and all fees are non-refundable.
                                All fees are exclusive of all taxes, levies, or duties imposed by taxing authorities,
                                and You shall be responsible for payment of all such taxes, levies, or duties.
                                DROP TABLE USERS also reserves the right, at any time, to impose or restructure any fees
                                charged for your use of the Services. DROP TABLE USERS will notify you in advance of
                                any changes with respect to fees it chooses to impose.
                            </p>
                        </li>
                        <li>
                            <h2 className="m-0">Exclusion of warranties</h2>
                            <ol>
                                <li>
                                    You expressly understand and agree that: your use of the service is at your sole
                                    risk. The service is provided on an "as is" and "as available" basis. DROP TABLE USERS
                                    and its subsidiaries, affiliates, officers, employees, agents, partners and
                                    licensors expressly disclaim all warranties of any kind, whether express or implied,
                                    including, but not limited to the implied warranties of merchantability, fitness for
                                    a particular purpose and non-infringement.
                                </li>
                                <li>
                                    <h3 className="m-0">DROP TABLE USERS makes no warranty that:</h3>
                                    <ol>
                                        <li>the service will meet your requirements or expectations;</li>
                                        <li>that your access to or use of the service will be uninterrupted;</li>
                                        <li>timely, secure or error free;</li>
                                        <li>hat any defects in the service will be corrected;</li>
                                        <li>
                                            that the service or any server through which you access the service is free
                                            of viruses or other harmful components.
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    Any material downloaded or otherwise obtained through the use of the service is
                                    accessed at your own discretion and risk, and you will be solely responsible for any
                                    damage to your computer system or loss of data that results from the download of any
                                    such material.
                                </li>
                                <li>
                                    No advice or information, whether oral or written, obtained by you from DROP TABLE USERS
                                    or through or from the service shall create any warranty not expressly
                                    stated in this terms of service.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 className="m-0">Limitation of liability</h2>
                            <p>
                                You expressly understand and agree that DROP TABLE USERS and its subsidiaries,
                                affiliates, officers, employees, agents, partners and licensors shall not be liable to
                                you for any direct, indirect, incidental, special, consequential or exemplary damages,
                                including, but not limited to, damages for loss of profits, goodwill, use, data or other
                                intangible losses (even if DROP TABLE USERS has been advised of the possibility of
                                such damages), resulting from: (i) the use or the inability to use the service; (ii) the
                                cost of procurement of substitute goods and service resulting from any goods, data,
                                information or service purchased or obtained or messages received or transactions
                                entered into through or from the service; (iii) unauthorized access to or alteration of
                                your transmissions or data; (iv) statements or conduct of any third party on the
                                service; (v) any other matter relating to the service. Some jurisdictions do not allow
                                the exclusion of certain warranties or the limitation or exclusion of liability for
                                incidental or consequential damages. accordingly, some of the above limitations may not
                                apply to you.
                            </p>
                        </li>
                        <li>
                            <h2 className="m-0">Indentification</h2>
                            <p>
                                Except for the indemnification obligations of the parties set out herein, to the fullest
                                extent permitted by applicable law, under no circumstances shall either party be liable
                                to the other party on account of any claim (whether based upon principles of contract,
                                warranty, negligence or other tort, breach of any statutory duty, the failure of any
                                limited remedy to achieve its essential purpose, or otherwise) for any special,
                                consequential, incidental, or exemplary damages, including but not limited to lost
                                profits, even if a party has been advised of the possibility of such damages. except for
                                the indemnification and confidentiality obligations of the parties set out herein, in no
                                event shall either party's liability exceed an amount equal to the fees paid by licensee
                                under this agreement. if you are dissatisfied with the software your sole and exclusive
                                remedy is to discontinue use of the software.
                            </p>
                        </li>
                        <li>
                            <h2 className="m-0">General legal terms</h2>
                            <ol>
                                <li>
                                    You agree that DROP TABLE USERS may provide you with notices, including those
                                    regarding changes to the Terms, by email, regular mail, or postings on the Services.
                                </li>
                                <li>
                                    The Terms, and your relationship with DROP TABLE USERS under the Terms, shall be
                                    governed by the laws of Germany without regard to its conflict of laws provisions.
                                    You and DROP TABLE USERS agree to submit to the exclusive jurisdiction of the
                                    courts located within Germany to resolve any legal matter arising from the Terms.
                                    October 21, 2011
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 className="m-0">Termination</h2>
                            <p>
                                You agree that DROP TABLE USERS, in its sole discretion, has the right (but not the
                                obligation) to delete or deactivate your account, block your email or IP address, or
                                otherwise terminate your access to or use of the Services (or any part thereof),
                                immediately and without notice, and remove and discard any content within the Services,
                                for any reason, including, without limitation, if DROP TABLE USERS believes that You
                                have acted inconsistently with the letter or spirit of the Terms of Use. Further, You
                                agree that DROP TABLE USERS shall not be liable to you or any third-party for any
                                termination of your access to the Services. Further, you agree not to attempt to use the
                                Services after said termination.
                            </p>
                        </li>
                        <li>
                            <h2 className="m-0">Non-commercial and educational use</h2>
                            <p>
                                You can use Muscula free of charge for non-commercial and educational usage only if:
                            </p>
                            <ul>
                                <li>received written permission (via email) to use this subscription;</li>
                                <li>
                                    website on which you placed the Muscula code does not contain elements of
                                    e-commerce, advertising, sales;
                                </li>
                                <li>
                                    website on which you placed the Muscula code is not owned by commercial company.
                                </li>
                            </ul>
                        </li>
                    </ol>
                </article>
                <Button className="btn-primary w-full mb-8 h-24 mt-4" onClick={() => acceptTermsOfUse()}>
                    I accept terms of service
                </Button>
                <br/>
                <br/>
            </Card>
        </section>
    );
});
